import { Routes, Route } from 'react-router-dom';
import LandingPage from './pages/LandingPage';
import SubscribePage from './pages/SubscribePage';

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LandingPage />} />
      <Route path="/subscribe" element={<SubscribePage />} />
    </Routes>
  );
}
